import CategoryItemsCount from 'Component/CategoryItemsCount';
import Html from 'Component/Html';
import { CategoryDetails as SourceCategoryDetails } from 'SourceComponent/CategoryDetails/CategoryDetails.component';

import './CategoryDetails.override.style';

/** @namespace AdvoxBasic/Component/CategoryDetails/Component/CategoryDetails */
export class CategoryDetails extends SourceCategoryDetails {
    renderCategoryCount() {
        const { isMatchingListFilter, totalItems } = this.props;

        if (totalItems === 0) {
            return null;
        }

        return <CategoryItemsCount isMatchingListFilter={isMatchingListFilter} />;
    }

    renderCategoryName() {
        const {
            category: { name, id },
        } = this.props;

        if (id && !name) {
            return null;
        }

        return (
            <div block="CategoryDetails" elem="Heading">
                <h1>{this.renderCategoryText()}</h1>
                {this.renderCategoryCount()}
            </div>
        );
    }

    renderBrandLogo() {
        const {
            brandData: { value, brand_id, image },
        } = this.props;

        if (brand_id && !image) {
            return null;
        }

        return (
            <div block="CategoryDetails" elem="Heading">
                <img src={image} alt={value} />
                {this.renderCategoryCount()}
            </div>
        );
    }

    renderBrandDescription() {
        const {
            brandData: { description },
            isCurrentCategoryLoaded,
        } = this.props;

        if (!isCurrentCategoryLoaded) {
            return this.renderCategoryDescriptionPlaceholder();
        }

        if (!description) {
            return null;
        }

        return <Html content={description} />;
    }

    render() {
        const { isBrand } = this.props;

        return (
            <article block="CategoryDetails" mods={{ isBrand }}>
                <div block="CategoryDetails" elem="Wrapper">
                    {isBrand ? this.renderBrandLogo() : this.renderCategoryName()}
                    <div block="CategoryDetails" elem="Description">
                        {isBrand ? this.renderBrandDescription() : this.renderCategoryDescription()}
                    </div>
                </div>
                {!isBrand && this.renderCategoryImage()}
            </article>
        );
    }
}

export default CategoryDetails;
